import(/* webpackMode: "eager", webpackExports: ["EventManagementSubnav"] */ "/vercel/path0/src/app/(marketing)/events/[id]/event-management-subnav.tsx");
